import { render } from "./CustomerFactors.vue?vue&type=template&id=4718beea&scoped=true"
import script from "./CustomerFactors.vue?vue&type=script&lang=js"
export * from "./CustomerFactors.vue?vue&type=script&lang=js"

import "./CustomerFactors.vue?vue&type=style&index=0&id=4718beea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4718beea"]])

export default __exports__